var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNamecheap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9979 14C55.7481 14 53.7983 15.2499 52.7734 17.0747L52.6484 17.3247L47.9488 26.5739L41.9993 38.298L45.899 45.9723L46.1239 46.3973C46.7239 47.4472 47.6238 48.3221 48.7237 48.8471C49.8236 48.2971 50.7236 47.4472 51.3235 46.3973L51.5485 45.9723L63.2225 22.9742L63.4975 22.4243C63.8225 21.6744 63.9974 20.8744 63.9974 19.9995C63.9974 16.6748 61.3227 14 57.9979 14ZM21.976 25.1491L18.1013 17.4997L17.8763 17.0747C17.2764 16.0248 16.3765 15.1499 15.2765 14.6249C14.1766 15.1749 13.2767 16.0248 12.6768 17.0747L12.4768 17.4997L0.802767 40.4978L0.52779 41.0477C0.202817 41.7977 0.027832 42.5976 0.027832 43.4725C0.027832 46.7722 2.70261 49.472 6.02733 49.472C8.27714 49.472 10.227 48.2221 11.2519 46.3973L11.3769 46.1473L16.0765 36.8981L22.001 25.1741L21.976 25.1491Z",
    fill: "#FF5000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9977 14C55.7479 14 53.773 15.2499 52.7731 17.0747L52.6481 17.3247L47.9485 26.5739L41.999 38.298L45.8987 45.9723L46.1237 46.3973C46.7236 47.4472 47.6235 48.3221 48.7235 48.8471C49.8234 48.2971 50.7233 47.4472 51.3232 46.3973L51.5482 45.9723L63.2222 22.9742L63.4972 22.4243C63.8222 21.6744 63.9972 20.8744 63.9972 19.9995C63.9972 16.6748 61.2974 14 57.9977 14Z",
    fill: "url(#paint0_linear_556_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00242 49.4721C8.25224 49.4721 10.2271 48.2222 11.227 46.3973L11.352 46.1473L16.0516 36.8981L22.0011 25.1741L18.1014 17.4998L17.8764 17.0748C17.2765 16.0249 16.3766 15.15 15.2766 14.625C14.1767 15.175 13.2768 16.0249 12.6769 17.0748L12.4769 17.4998L0.802862 40.4978L0.502888 41.0728C0.177915 41.8227 0.00292969 42.6226 0.00292969 43.4976C0.00292969 46.7973 2.6777 49.4721 6.00242 49.4721Z",
    fill: "url(#paint1_linear_556_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9758 25.1491L18.1011 17.4997L17.8761 17.0747C17.2762 16.0248 16.3763 15.1499 15.2764 14.6249C15.6263 14.45 16.0263 14.3 16.4013 14.2C16.8762 14.075 17.4012 14 17.9011 14H26.1005C28.3503 14.025 30.3001 15.2499 31.325 17.0747L31.5 17.4997L42.0241 38.323L45.8988 45.9723L46.1238 46.3973C46.7237 47.4472 47.6236 48.3221 48.7235 48.8471C48.3736 49.022 47.9736 49.172 47.5986 49.272C47.1237 49.397 46.5987 49.472 46.0738 49.472H37.9245C35.6746 49.447 33.7248 48.2221 32.6999 46.3973L32.4749 45.9723L21.9758 25.1491Z",
    fill: "#FF8C44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_556_8",
    x1: 335.058,
    y1: 3322.55,
    x2: 2830.64,
    y2: 1189.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4202C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04166,
    stopColor: "#D82D2B",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#E25226",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3167,
    stopColor: "#EB7123",
    stopOpacity: 0.683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4635,
    stopColor: "#F28920",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    stopColor: "#F69A1E",
    stopOpacity: 0.381
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#F9A41D",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA71D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_556_8",
    x1: 1905.57,
    y1: 190.254,
    x2: -590.035,
    y2: 2323.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4202C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04166,
    stopColor: "#D82D2B",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#E25226",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3167,
    stopColor: "#EB7123",
    stopOpacity: 0.683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4635,
    stopColor: "#F28920",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    stopColor: "#F69A1E",
    stopOpacity: 0.381
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#F9A41D",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA71D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 35.497,
    fill: "white",
    transform: "translate(0 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamecheap);
export default __webpack_public_path__ + "static/media/Namecheap.1a7ed46069d0d90cabed54a87364648d.svg";
export { ForwardRef as ReactComponent };